<template>
  <NuxtLink
    :to="url"
    class="group/button hyphens-auto h-full grid grid-rows-subgrid grid-cols-1 row-span-9"
  >
    <article
      class="border-primary-100 border-2 rounded-large p-10 pb-15 hover:bg-blue-50 transition-all ease-in-out duration-250 h-full grid grid-rows-subgrid grid-cols-1 row-span-9"
      :class="{ 'bg-primary-50': isSingularEvent }"
    >
      <h3 class="text-4xl font-bold text-blue-900 mb-10 row-start-3">
        {{ title }}
      </h3>

      <FieldItemTypeImage
        v-if="image"
        rounded
        v-bind="image"
        :config="imageStyle"
        hide-caption
        class="mb-15 rounded row-start-1"
        img-class="w-full"
      />

      <div
        v-if="date"
        class="text-2xl font-bold text-primary-500 mb-10 row-start-2"
      >
        {{ date }}
      </div>

      <time class="block font-bold text-blue-900 mb-15 row-start-4">
        <template v-if="isWholeDay">{{
          $texts('event.entireDay', 'Ganztags')
        }}</template>
        <template v-else>{{
          $texts('event.timeOnly', '@time Uhr').replace('@time', time)
        }}</template>
      </time>

      <address
        class="block not-italic font-bold text-primary-700 mb-40 row-start-5"
      >
        {{ places.join(', ') }}
      </address>

      <div v-if="hasMultiple" class="mb-10">
        <div class="tag is-dark">
          <SpriteSymbol name="calendar" aria-hidden="true" />
          {{ $texts('event.hasMultiple', 'Mehrere Termine') }}
        </div>
      </div>

      <div v-if="isRecurring" class="mb-10">
        <div class="tag">
          <SpriteSymbol name="calendar" aria-hidden="true" />
          {{ $texts('event.isRecurring', 'Fortlaufender Termin') }}
        </div>
      </div>

      <div v-if="hasSignUp" class="mb-10">
        <div class="tag is-light">
          <SpriteSymbol name="pen" aria-hidden="true" />
          {{ $texts('event.withSignUp', 'Mit Anmeldung') }}
        </div>
      </div>

      <div class="button is-link row-start-9">
        {{ $texts('event.details', 'Details') }}
        <span class="sr-only">{{
          $texts('accessibility.forThisEvent', 'zu dieser Veranstaltung')
        }}</span>
      </div>
    </article>
  </NuxtLink>
</template>

<script lang="ts" setup>
import type { ImageItemFragment } from '#graphql-operations'

defineProps<{
  url: string
  image?: ImageItemFragment
  date?: string
  title: string
  time: string
  isWholeDay?: boolean
  places: string[]
  isSingularEvent?: boolean
  hasMultiple?: boolean
  isRecurring?: boolean
  hasSignUp?: boolean
}>()

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 16 / 9,
  sizes: {
    sm: 370,
    md: 331,
    lg: 365,
    xl: 310,
  },
})
</script>
